import {
  CreditCard,
  Calendar,
  LayoutDashboard,
  Users,
  UserCog,
  ShoppingBasket,
  UtensilsCrossed,
  Wine,
  Settings,
  User,
  Building,
  Grid,
  ShieldCheck,
  PackageOpen,
  CalendarCogIcon,
} from "lucide-react";

import { orgRoutes } from "./routes";
import type { NavItem } from "@/types/components";

export const dashboardNavItems: NavItem[] = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    href: orgRoutes.dashboard,
  },
  {
    title: "Events",
    icon: Calendar,
    href: orgRoutes.events,
  },
  {
    title: "Events Change Requests",
    icon: CalendarCogIcon,
    href: orgRoutes.eventChangeRequests,
  },
  {
    title: "Customers",
    icon: Users,
    href: orgRoutes.customers,
  },
  {
    title: "Staffs",
    icon: UserCog,
    href: orgRoutes.staffs,
  },
  {
    title: "Inventories",
    icon: PackageOpen,
    href: "#",
    submenu: [
      {
        title: "Ingredient",
        icon: ShoppingBasket,
        href: `${orgRoutes.inventories}/ingredient`,
      },
      {
        title: "Meal",
        icon: UtensilsCrossed,
        href: `${orgRoutes.inventories}/meal`,
      },
      {
        title: "Drink",
        icon: Wine,
        href: `${orgRoutes.inventories}/drink`,
      },
    ],
  },
  {
    title: "Org. Management",
    icon: Building,
    href: orgRoutes.orgMgt,
    submenu: [
      {
        title: "Departments",
        href: `${orgRoutes.orgMgt}/department`,
        icon: Grid,
      },
      {
        title: "Roles",
        href: `${orgRoutes.orgMgt}/role`,
        icon: ShieldCheck,
      },
    ],
  },
  {
    title: "Settings",
    icon: Settings,
    href: orgRoutes.settings,
    submenu: [
      {
        title: "Account",
        href: `${orgRoutes.settings}/account`,
        icon: User,
      },
      {
        title: "Billing",
        href: `${orgRoutes.settings}/billing`,
        icon: CreditCard,
      },
    ],
  },
];
